/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, Injector, Input, OnInit } from '@angular/core';
import { PoSelectOption, PoComboOption } from '@po-ui/ng-components';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { TypeOfPerson } from 'src/app/shared/enum/type-of-person.enum';
import { BaseAccountFormComponent } from '../base-account-form.component';
import { IGeneralDataInfo } from '../shared/interface/IGeneralDataInfo';
import { Functions } from 'src/app/shared/functions/functions';
import { UntypedFormGroup } from '@angular/forms';
import { SalesService } from '../../../services/sales.service';

@Component({
  selector: 'tgv-account-general-data',
  standalone: false,
  templateUrl: './account-general-data.component.html'
})
export class AccountGeneralDataComponent extends BaseAccountFormComponent implements OnInit {
  @Input() typeOfPerson: TypeOfPerson;
  @Input() isOnline: boolean;
  @Input() isDisableField = 'false';
  typeOptions: PoComboOption[] = [];
  typePersonOptions: PoSelectOption[];
  generalDataInfo: IGeneralDataInfo;
  codeAndStoreRegexMask = new RegExp(/[^A-Za-z0-9 ]/g);

  constructor(
    override injector: Injector,
    private functions: Functions,
    private salesService: SalesService
  ){
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.onInitPage();
    this.listenChangeInForm();
  }

  getNameOfFields(): string[] {
    return [
      'cgc',
      'name',
      'code',
      'store',
      'fantasy',
      'estadualregistration',
      'municipalregistration',
      this.isCustomer ? 'customertype' : 'prospecttype',
      'persontype'
    ];
  }

  onInitPage(): void {
    this.generalDataInfo = this.accountService.getGeneralDataByTypeOfPerson(this.typeOfPerson, this.cPaisLoc);
    this.typePersonOptions = this.accountService.getTypePersonOptions();
    this.salesService.getComboValue('A1_TIPO').subscribe(options => {
      this.typeOptions = options;
    });
  }

  listenChangeInForm(): void {
    this.form.valueChanges.pipe(debounceTime(100), distinctUntilChanged()).subscribe(form => {
      this.formatFormWithRegex(form);
    });
  }

  formatFormWithRegex(form: UntypedFormGroup): void {
    const code = this.functions.returnStringWithRegex(form['code'], this.codeAndStoreRegexMask);
    const store = this.functions.returnStringWithRegex(form['store'], this.codeAndStoreRegexMask);
    if (code !== form['code'] || store !== form['store']) {
      form['code'] = code;
      form['store'] = store;
      this.form.patchValue(form, { emitEvent: false });
    }
  }
}
